/* eslint-disable */
import { activeSync } from '../api.js'

import notifications from '../notifications.js'

import { isEmpty } from 'lodash'

async function _getRoutePullList() {
  let response = await activeSync.getRoutePullList()
  return response.data
}

async function _getOrInitRoutePull(selectedPartitions, date, options, forceNew) {
  if (isEmpty(selectedPartitions)) {
    throw 'Selected Partitions cannot be empty'
  }

  try {
    let body = {
      'partitions': selectedPartitions,
      'date': date,
      'options': options,
      'force_new': forceNew,
    }
    let response = await activeSync.postRoutePullEntry(body)
    return response.data.id
  }
  catch (error) {
    _clearPollingInterval()
    notifications.pushError(`Failed to start Route Pull! ${error.response.data.error}`, error)
    throw 'Failed to start Route Pull'
  }
}


var _vars = {
  currRoutePullId: undefined,
  contentPollingIntervalId: undefined,
}


function _clearPollingInterval() {
  if (_vars.contentPollingIntervalId) {
    clearInterval(_vars.contentPollingIntervalId)
    _vars.contentPollingIntervalId = undefined
  }
}

async function _getRoutePullData(routePullTaskId) {
  try {
    let response = await activeSync.getRoutePullData(routePullTaskId)
    return response.data
  }
  catch (error) {
    _clearPollingInterval()
    notifications.pushError(`Failed to load Route Pull Content! ${error.response.data.error}`, error)
  }
}

function _initDataPolling(routePullId, uiDataCallback) {
  async function pollingCallback() {
    let content = await _getRoutePullData(routePullId)
    if (content.progress !== 'running') {
      _clearPollingInterval()
    }
    uiDataCallback(content)
  }

  _vars.contentPollingIntervalId = setInterval(pollingCallback, 4000)
}

export default {
  getRoutePullList: _getRoutePullList,

  getOrInitRoutePull: _getOrInitRoutePull,
  getRoutePullData: _getRoutePullData,
  initDataPolling: _initDataPolling,
}
